// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__H0ONX","header_bar":"SectionHeader_header_bar__yO71r"};